<div class="row">
	<div class="col-auto prefix-content" [hidden]="!hasPrefixContent" #prefixContent>
		<ng-content select="[prefix-content]" />
	</div>
	<div class="col">
		<div class="row">
			<div class="label col-12" [ngClass]="{ 'active': focusedInput }">
				<h4><ng-content select="label" /></h4>
			</div>
			<div class="col-12" [hidden]="!hasInput" #inputContent>
				<ng-content select="input, custom-input, custom-select, date-input, date-picker, time-picker, editable-field" />
			</div>
			<div class="col-12" [hidden]="!hasRawContent" #rawContent>
				<ng-content />
			</div>
		</div>
	</div>
</div>